<div class="page-header">
    <h1>Evidence Archive</h1>
    <div class="project-select">
        Project:
        <p-select [options]="projects" optionLabel="name" optionValue="projectId" [(ngModel)]="selectedProject"
            (onChange)="onProjectChanged($event)" [ngModelOptions]="{standalone: true}">
        </p-select>
    </div>
</div>
<p-splitter [panelSizes]="[18, 82]" [style]="{ height: '100vh' }" styleClass="mb-5">
    <!-- Control Summary -->
    <ng-template pTemplate>
        <div class="control-div full-height">
            <p-table *ngIf="remainingControls && remainingControls.length" [value]="remainingControls"
                [scrollable]="true" scrollHeight="flex" [columns]="cols" [resizableColumns]="true" [autoLayout]="true">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" pTooltip="{{ col.tooltip }}"
                            tooltipPosition="top">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-control>
                    <tr>
                        <td>
                            <i *ngIf="control.subItems && control.subItems.length"
                                [ngClass]="expandedSmallItem[control.complianceAreaControlId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                                (click)="expandedSmallItem[control.complianceAreaControlId] = !expandedSmallItem[control.complianceAreaControlId]; $event.stopPropagation(); $event.preventDefault();"></i>
                            {{ control.complianceAreaControlId }}
                        </td>
                        <td>
                            <span [ngClass]="{ 'dot': true, 'dot-true': control.ps, 'dot-false': !control.ps }"></span>
                        </td>
                        <td>
                            <span [ngClass]="{ 'dot': true, 'dot-true': control.cs, 'dot-false': !control.cs }"></span>
                        </td>
                    </tr>
                    <ng-container *ngIf="control.subItems && expandedSmallItem[control.complianceAreaControlId]">
                        <tr *ngFor="let subItem of control.subItems">
                            <td style="padding-left: 20px;">{{ subItem.complianceAreaControlId }}</td>
                            <td>
                                <span
                                    [ngClass]="{ 'dot': true, 'dot-true': subItem.ps, 'dot-false': !subItem.ps }"></span>
                            </td>
                            <td>
                                <span
                                    [ngClass]="{ 'dot': true, 'dot-true': subItem.cs, 'dot-false': !subItem.cs }"></span>
                            </td>
                        </tr>
                    </ng-container>
                </ng-template>
            </p-table>
        </div>
    </ng-template>
    <!-- Evidence -->
    <ng-template pTemplate>
        <div class="evidence">
            <mat-accordion>
                <!-- (opened)="onCategoryOpened(category)" -->
                <mat-expansion-panel *ngFor="let category of categories">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ category.category }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let control of category.controls">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ control.complianceAreaControlId }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <!-- Year Dropdown -->
                            <div *ngIf="control.evidence.length" style="margin-bottom: 10px;">
                                <p-select [options]="years" [editable]="true" placeholder="Year"
                                    [(ngModel)]="control.selectedYear" (onChange)="filterEvidenceByYear(control)">
                                </p-select>
                            </div>

                            <!-- Evidence for the control -->
                            <p *ngIf="!control.evidence.length">No evidence available</p>
                            <p-table *ngIf="getFilteredEvidence(control).length" [value]="getFilteredEvidence(control)"
                                [scrollable]="true" scrollHeight="200px">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Submitter</th>
                                        <th>Notes</th>
                                        <th>Actions</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-evidence>
                                    <tr>
                                        <td><button mat-button (click)="downloadEvidence(control, evidence.name)">{{
                                                evidence.name }}</button></td>
                                        <td>{{ evidence.date | date }}</td>
                                        <td>{{ evidence.submitter || 'Unknown' }}</td>
                                        <td>
                                            <div *ngIf="evidence.editMode">
                                                <input matInput [(ngModel)]="evidence.notes" placeholder="Edit Notes" />
                                            </div>
                                            <div *ngIf="!evidence.editMode">
                                                {{ evidence.notes || 'None' }}
                                            </div>
                                        </td>
                                        <td>
                                            <button *ngIf="!evidence.editMode" type="button" pButton
                                                class="risksponge-button" title= "Edit Evidence Notes"
                                                (click)="evidence.editMode = true; evidence.oldNotes = evidence.notes"
                                                icon="pi pi-pencil">
                                            </button>
                                            <button *ngIf="evidence.editMode" type="button" pButton
                                                class="risksponge-button" title="Save"
                                                (click)="evidence.editMode = false; saveEvidenceNotes(evidence)"
                                                icon="pi pi-save">
                                            </button>
                                            <button *ngIf="evidence.editMode" type="button" pButton
                                                class="risksponge-button" title="Cancel"
                                                (click)="evidence.editMode = false; evidence.notes = evidence.oldNotes;"
                                                icon="pi pi-times">
                                            </button>
                                            <button type="button" title="Delete Evidence" pButton
                                                class="risksponge-button" (click)="deleteEvidence(evidence)"
                                                icon="pi pi-trash">
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </mat-expansion-panel>
                    </mat-accordion>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </ng-template>
</p-splitter>
